export enum AppRoutes {
  HOME = 'home',
}
